var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("swiper", {
        ref: "storiesContainer",
        class: [_vm.storiesFixed, _vm.isSmallImages, "rb-stories-background"],
        style: [{ top: _vm.setOffset }],
        attrs: {
          "data-element-id": "X_Hp_Prod_StoriesThumbs",
          config: _vm.defaultConfig,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "wrapper",
              fn: function () {
                return [
                  _c(
                    "ul",
                    { staticClass: "swiper-wrapper rb-stories-swiper" },
                    [_vm._t("default")],
                    2
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _c("div", { ref: "cloneContainer", style: [{ height: _vm.setHeight }] }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }